import { useQuery } from "@tanstack/react-query";
import VideoRow from "@/components/video-row";
import Header from "@/components/header";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "wouter";
import { useTranslation } from "@/i18n/LanguageContext";

interface Category {
  id: number;
  name: string;
  sortOrder: number;
  visible: boolean;
}

export default function Home() {
  const { t } = useTranslation();
  const { data: categories } = useQuery<Category[]>({
    queryKey: ["/api/categories"],
  });

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-16 md:pt-24 pb-8 md:pb-12 space-y-6 md:space-y-8">
        {/* Hero Section */}
        <section className="relative px-4 sm:px-6 py-10 sm:py-16 mx-auto text-center text-white max-w-7xl">
          <div className="space-y-4 md:space-y-6">
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl lg:text-6xl">
              <span className="block text-yellow-500">{t("home.hero_title")}</span>
              <span className="block">{t("home.hero_subtitle")}</span>
            </h1>
            <p className="max-w-2xl mx-auto text-base sm:text-lg md:text-xl text-gray-300">
              {t("home.hero_description")}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
              <Link href="/desafios-cacatais" className="w-full sm:w-auto">
                <Button variant="default" className="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 text-base sm:text-lg font-medium rounded-md bg-yellow-500 hover:bg-yellow-600">
                  {t("home.explore_puzzles")}
                </Button>
              </Link>
              <Link href="/puzzles/create" className="w-full sm:w-auto">
                <Button variant="outline" className="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 text-base sm:text-lg font-medium rounded-md border-yellow-500 text-yellow-500 hover:bg-yellow-500/10">
                  {t("home.create_puzzle")}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Video Rows Section */}
        {categories && categories.length > 0 && (
          <section className="space-y-4 md:space-y-6">
            <h2 className="px-4 sm:px-6 text-xl sm:text-2xl font-bold text-white">
              {t("home.video_section_title")}
            </h2>
            <div className="space-y-6 md:space-y-8">
              {categories.map((category) => (
                <VideoRow 
                  key={category.id}
                  title={category.name}
                  categoryId={category.id}
                />
              ))}
            </div>
          </section>
        )}
      </main>
    </div>
  );
}